import React from "react";
import { Link } from "react-router-dom";
import EventCard from "../../../../common/components/EventCard";
import { getUpcomingEvents } from "../../../../content/events";

// Homepage "Upcoming Events". Hidden entirely when no dated events are published.
const Events = () => {
  const upcoming = getUpcomingEvents().slice(0, 3);
  if (upcoming.length === 0) return null;

  return (
    <section className="mrf-section" aria-labelledby="events-heading">
      <div className="mrf-container">
        <h2 id="events-heading" className="mrf-heading mrf-heading--center">Upcoming Events</h2>
        <div className="mrf-grid-3" style={{ marginTop: 28 }}>
          {upcoming.map((event) => (
            <EventCard key={`${event.title}-${event.startDate}`} event={event} />
          ))}
        </div>
        <p style={{ textAlign: "center", marginTop: 24 }}>
          <Link className="mrf-link" to="/aboutUs/events">See the full Events Calendar</Link>
        </p>
      </div>
    </section>
  );
};

export default Events;
